import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDoorOpen = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19 17.437V5.104c0-1.3-1.078-2.354-2.409-2.354H7.41C6.079 2.75 5 3.804 5 5.104v15.212"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19 18.692V6.056c0-1.622-1.526-2.834-3.153-2.504l-5.131 1.04C9.5 4.84 8.628 5.884 8.628 7.096v10.556c0 1.212.872 2.257 2.088 2.503l5.131 1.04c1.627.33 3.153-.882 3.153-2.503"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M12 11.533v1.682"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDoorOpen);
export default ForwardRef;
